export enum InventoryQueryKeys {
  InventoryResources = 'inventoryResources',
  InventoryQuery = 'inventoryQuery',
  CanDeleteInventoryQuery = 'canDeleteInventoryQuery',
  InventoryFilterOptions = 'inventoryFilterOptions',
  InventoryResource = 'inventoryResource',
  InventoryPermissions = 'inventoryPermissions',
  InventoryCounts = 'inventoryCounts',
}
